export const InactivePlayerScreen = ({ onClick }: { onClick: () => void }) => (
  <img
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    }}
    src="welcomeInactivePlayer.png"
    onClick={onClick}
  />
)
